module.exports = __webpack_public_path__ + "img/client.91192bb8.jpg";